module.exports = __webpack_public_path__ + "static/media/C4.3b46c0c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C4.mp4
// module id = 4dMj
// module chunks = 8